

export const baseUrl = () => {
    return window.REACT_APP_BASE_URL_FRONTEND || process.env.BASE_URL_FRONTEND || ''
  }